import React from 'react';
import classnames from 'classnames/bind';
import { HelpTooltip, AudienceSectionIcon } from 'taboola-ultimate-ui';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import UnsupportedConfiguration from 'components/UnsupportedConfiguration/UnsupportedConfiguration';
import { FORM_MODES } from 'config/formModes';
import SectionHeader from 'modules/campaigns/components/Form/SectionHeader/SectionHeader';
import { ContextualSegmentsField } from 'modules/campaigns/modules/common-campaign-form/components/ContextualSegments/ContextualSegmentsField';
import MarketplaceAudiencesField from 'modules/campaigns/modules/common-campaign-form/components/MarketplaceAudiences/MarketplaceAudiencesField';
import { useMarketplaceAudienceTargetingValues } from 'modules/campaigns/modules/common-campaign-form/components/MarketplaceAudiences/hooks/useMarketplaceAudienceTargetingValues';
import { MyAudiencesField } from 'modules/campaigns/modules/common-campaign-form/components/MyAudiencesField/MyAudiencesField';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData/FormDataContext';
import useFormFieldValue from 'modules/taboola-common-frontend-modules/formData/hooks/useFormFieldValue';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { AudienceTargetingFirstCampaignIndication } from './AudienceTargetingFirstCampaignIndication';
import AudienceTargetingTooltipLegacy from './AudienceTargetingTooltipLegacy';
import styles from './audienceTargetingSectionLegacy.module.scss';

const classNameBuilder = classnames.bind(styles);

const AudienceTargetingSectionLegacy = ({ isInitiallyCollapsed }) => {
    const { mode } = useFormDataContext();
    const { isValidTargeting: validTargetingMarketplace = true } = useMarketplaceAudienceTargetingValues();

    const { value: validTargetingContextual = true } = useFormFieldValue({
        field: 'campaignTargeting.contextualSegmentsTargeting.validTargeting',
    });
    const { value: validTargetingMyAudiences = true } = useFormFieldValue({
        field: 'campaignTargeting.myAudienceTargeting.validTargeting',
    });
    const containerClassName = classNameBuilder('container', { 'new-campaign': mode === FORM_MODES.CREATE });

    return (
        <div className={containerClassName}>
            <CommonCollapsibleCard
                id="CAMPAIGN_AUDIENCE_TARGETING"
                header={
                    <SectionHeader
                        headerIcon={<AudienceSectionIcon />}
                        headerText={
                            <FormattedMessage
                                id="campaign.editor.audience.targeting"
                                defaultMessage="Audience Targeting"
                            />
                        }
                    />
                }
                isInitiallyCollapsed={isInitiallyCollapsed}
                description={
                    <>
                        <FormattedMessage
                            id="campaign.editor.audience.targeting.description"
                            defaultMessage="Targeting more than one audience type (i.e. using both Marketplace Audiences and My Audiences) will narrow target audience and limit campaign reach."
                        />
                        <HelpTooltip iconClassName={styles['help-tooltip']}>
                            <AudienceTargetingTooltipLegacy />
                        </HelpTooltip>
                        <AudienceTargetingFirstCampaignIndication />
                    </>
                }
            >
                {validTargetingMarketplace && validTargetingMyAudiences && validTargetingContextual ? (
                    <div>
                        <MarketplaceAudiencesField />
                        <MyAudiencesField />
                        <ContextualSegmentsField />
                    </div>
                ) : (
                    <UnsupportedConfiguration />
                )}
            </CommonCollapsibleCard>
        </div>
    );
};

export default AudienceTargetingSectionLegacy;
